export default {
    components: {
        ui: {
            handwritecanvas: "components.ui.handwritecanvas",
            localizableInput: "components.ui.localizableInput",
            servicepricedisplay: "components.ui.servicepricedisplay",
            servicepriceeditor: "components.ui.servicepriceeditor",
            reservationdetail: "components.ui.reservationdetail",
        },
        statistics: {
            sourceReferrerDistribution: "components.statistics.sourceReferrerDistribution",
        },
    },
    layouts: {
        account: "layouts.account",
        base: "layouts.base",
        admin: "layouts.admin",
        main: "layouts.main",
        userProfile: "layouts.userProfile",
        portal: "layouts.portal",
        corporate: "layouts.corporate",
        plain: "layouts.plain",
        practice: "layouts.practice",
        dashboard: "layouts.dashboard",
        errors: "layouts.errors",
        navbars: {
            admin: "layouts.navbars.admin",
            auth: "layouts.navbars.auth",
            portal: "layouts.navbars.portal",
            mobile: "layouts.navbars.mobile",
        },
        sidebar: {
            sidebar: "layouts.sidebar.sidebar",
        },
        footers: {
            portalfooter: "layouts.footers.portalfooter",
        },
    },
    screens: {
        account: {
            login: "screens.account.login",
            userlogin: "screens.account.userlogin",
            userregister: "screens.account.userregister",
            forgotpassword: "screens.account.forgotpassword",
            changepassword: "screens.account.changepassword",
            register: "screens.account.register",
        },
        admin: {
            service: "screens.admin.service",
            dashboard: "screens.admin.dashboard",
            workbench: "screens.admin.workbench",
            currencyInfo: "screens.admin.currencyInfo",
            statistics: {
                userstatistic: "screens.admin.statistics.userstatistic",
                providerstatistic: "screens.admin.statistics.providerstatistic",
                marketerstatistic: "screens.admin.statistics.marketerstatistic",
                orderstatistic: "screens.admin.statistics.orderstatistic",
                incomestatistic: "screens.admin.statistics.incomestatistic",
                activeuserconfig: "screens.admin.statistics.activeuserconfig",
                operationstatistic: "screens.admin.statistics.operationstatistic",
            },
            income: {
                systemincome: "screens.admin.income.systemincome",
                regionincomelist: "screens.admin.income.regionincomelist",
                systemincomevalidation: "screens.admin.income.systemincomevalidation",
                consumerincome: "screens.admin.income.consumerincome",
                providerincome: "screens.admin.income.providerincome",
                marketerincome: "screens.admin.income.marketerincome",
            },
            region: "screens.admin.region",
            regionservice: "screens.admin.regionservice",
            regionsetting: "screens.admin.region.regionsetting",
            regionjoinrequest: "screens.admin.regionjoinrequest",
            regionjoinrequestdetail: "screens.admin.regionjoinrequestdetail",
            user: {
                manageemployee: "screens.admin.user.manageemployee",
                manageconsumer: "screens.admin.user.manageconsumer",
                manageuser: "screens.admin.user.manageuser",
                manageprovider: "screens.admin.user.manageprovider",
                manageagent: "screens.admin.user.manageagent",
                manageregionuser: "screens.admin.user.manageregionuser",
                managestoreuser: "screens.admin.user.managestoreuser",
                managecloudstoreuser: "screens.admin.user.managecloudstoreuser",
                managemarketer: "screens.admin.user.managemarketer",
                teamcertificationmanagement: "screens.admin.user.teamcertificationmanagement",
                teamcertificationmanagementdetail: "screens.admin.user.teamcertificationmanagementdetail",
                useractivity: "screens.admin.user.useractivity",
                userdetail: "screens.admin.user.userdetail",
                userauthentication: "screens.admin.user.userauthentication",
            },
            manager: {
                feedback: "screens.admin.manager.feedback",
                feedbackdetail: "screens.admin.manager.feedbackdetail",
                report: "screens.admin.manager.report",
                reportdetail: "screens.admin.manager.reportdetail",
                consumerreview: "screens.admin.manager.consumerreview",
                consumerreviewdetail: "screens.admin.manager.consumerreviewdetail",
                providerreview: "screens.admin.manager.providerreview",
                providerreviewdetail: "screens.admin.manager.providerreviewdetail",
            },
            error: {
                details: "screens.admin.error.details",
                list: "screens.admin.error.list",
                dashboard: "screens.admin.error.dashboard",
            },
            featureconfiguration: "screens.admin.featureconfiguration",
            setting: "screens.admin.setting",
            servicesetting: "screens.admin.servicesetting",
            oncallsetting: "screens.admin.oncallsetting",
            servicetype: "screens.admin.servicetype",
            store: {
                default: "screens.admin.store.default",
                detail: "screens.admin.store.detail",
                storeroomtype: "screens.admin.store.storeroomtype",
                storeroom: "screens.admin.store.storeroom",
                storeprovider: "screens.admin.store.storeprovider",
                storeguest: "screens.admin.store.storeguest",
                storeservice: "screens.admin.store.storeservice",
                roomstatus: "screens.admin.store.roomstatus",
                reservationstatus: "screens.admin.store.reservationstatus",
                reservationlist: "screens.admin.store.reservationlist",
                account: "screens.admin.store.account",
                dashboard: "screens.admin.store.dashboard",
                collectionbill: "screens.admin.store.collectionbill",
                collectionbilldetail: "screens.admin.store.collectionbilldetail",
                settlementpayout: "screens.admin.store.settlementpayout",
                settlementpayoutdetail: "screens.admin.store.settlementpayoutdetail",
                providercommission: "screens.admin.store.providercommission",
                providercommissiondetail: "screens.admin.store.providercommissiondetail",
                expenseledger: "screens.admin.store.expenseledger",
                expenseledgerdetail: "screens.admin.store.expenseledgerdetail",
                coupon: "screens.admin.store.coupon",
                storeproviderschedule: "screens.admin.store.storeproviderschedule",
            },
            storejoinrequest: "screens.admin.storejoinrequest",
            todotask: "screens.admin.todotask",
            cloudstore: "screens.admin.cloudstore",
            cloudstorerequest: "screens.admin.cloudstorerequest",
            gpsmonitor: "screens.admin.gpsmonitor",
            helpcentersetting: "screens.admin.helpcentersetting",
            verifycodemanage: "screens.admin.verifycodemanage",
            transaction: {
                consumerwithdrawal: "screens.admin.transaction.consumerwithdrawal",
                providerwithdrawal: "screens.admin.transaction.providerwithdrawal",
                marketerwithdrawal: "screens.admin.transaction.marketerwithdrawal",
                regionwithdrawal: "screens.admin.transaction.regionwithdrawal",
                storewithdrawal: "screens.admin.transaction.storewithdrawal",
                agentwithdrawal: "screens.admin.transaction.agentwithdrawal",
            },
            reservation: "screens.admin.reservation",
            reservationdetail: "screens.admin.reservationdetail",
            debt: "screens.admin.debt",
            regionreservation: "screens.admin.regionreservation",
            reservationrewardpenalty: "screens.admin.reservationrewardpenalty",
            discount: {
                promotion: "screens.admin.discount.promotion",
                coupon: "screens.admin.discount.coupon",
                announcement: "screens.admin.discount.announcement",
                freereservation: "screens.admin.discount.freereservation",
                poster: "screens.admin.discount.poster",
                activityparticipants: "screens.admin.discount.activityparticipants",
            },
            socialmediamanage: "screens.admin.socialmediamanage",
            chat: {
                list: "screens.admin.chat.list",
                chat: "screens.admin.chat.chat",
            },
            mockdata: "screens.admin.mockdata",
            datacleanup: "screens.admin.datacleanup",
            historysettings: "screens.admin.historysettings",
            chooseregion: "screens.admin.chooseregion",
            profile: "screens.admin.profile",
            account: "screens.admin.account",
            request: {
                cancelReservationWithoutLiabilityRequest: "screens.admin.request.cancelReservationWithoutLiabilityRequest",
                userWithdrawalRequest: "screens.admin.request.userWithdrawalRequest",
                reservationRewardPenaltyRequest: "screens.admin.request.reservationRewardPenaltyRequest",
                freeReservationRequest: "screens.admin.request.freeReservationRequest",
                rejectReservationRequest: "screens.admin.request.rejectReservationRequest",
                reservationRefundRequest: "screens.admin.request.reservationRefundRequest",
                newServiceTypeRequest: "screens.admin.request.newServiceTypeRequest",
                teamCertificationRequest: "screens.admin.request.teamCertificationRequest",
                providerStoreJoinRequest: "screens.admin.request.providerStoreJoinRequest",
            },
        },
        portal: {
            home: "screens.portal.home",
            consumer: "screens.portal.consumer",
            joinus: "screens.portal.joinus",
            provider: "screens.portal.provider",
            socialcontentlist: "screens.portal.socialcontentlist",
            agent: "screens.portal.agent",
            join: "screens.portal.join",
            about: "screens.portal.about",
            privacy: "screens.portal.privacy",
            terms: "screens.portal.terms",
            storejoin: "screens.portal.storejoin",
            regionjoin: "screens.portal.regionjoin",
            cloudstorejoin: "screens.portal.cloudstorejoin",
            marketer: "screens.portal.marketer",
            downloadconsumerapp: "screens.portal.downloadconsumerapp",
            downloadproviderapp: "screens.portal.downloadproviderapp",
            payment: "screens.portal.payment",
        },
        plain: {
            userhomeworkunit: "screens.plain.userhomeworkunit",
        },
        dashboards: {
            default: "screens.dashboards.default",
            projects: "screens.dashboards.projects",
            ecommerce: "screens.dashboards.ecommerce",
            marketing: "screens.dashboards.marketing",
            social: "screens.dashboards.social",
            bidding: "screens.dashboards.bidding",
            learning: "screens.dashboards.learning",
            logistics: "screens.dashboards.logistics",
        },
        corporate: {
            about: "screens.corporate.about",
            team: "screens.corporate.team",
            faqs: "screens.corporate.faqs",
            contact: "screens.corporate.contact",
            pricing: "screens.corporate.pricing",
            license: "screens.corporate.license",
        },
        userProfile: {
            details: "screens.userProfile.details",
            preferences: "screens.userProfile.preferences",
            information: "screens.userProfile.information",
            security: "screens.userProfile.security",
            activity: "screens.userProfile.activity",
            actions: "screens.userProfile.actions",
            help: "screens.userProfile.help",
            feedback: "screens.userProfile.feedback",
        },
        auth: {
            signup: "screens.auth.signup",
            signin: "screens.auth.signin",
            welcome: "screens.auth.welcome",
            verifyEmail: "screens.auth.verifyEmail",
            passwordReset: "screens.auth.passwordReset",
            accountDelete: "screens.auth.accountDelete",
        },
        errors: {
            error400: "screens.errors.error400",
            error403: "screens.errors.error403",
            error404: "screens.errors.error404",
            error500: "screens.errors.error500",
            error503: "screens.errors.error503",
        },
        about: "screens.about",
        default: "screens.default",
    },
    session: "session",
    taskqueue: "taskqueue",
};
